// src/components/ModalWrap.jsx
export function ModalWrap({ title, onClose, wide = false, children }) {
  return (
    <div className={`modal${wide ? " wide" : ""}`}>
      <div className="modal-drag-handle" />
      <div className="modal-header">
        <div className="modal-title">{title}</div>
        <button className="btn-small" onClick={onClose}>✕</button>
      </div>
      {children}
    </div>
  );
}
